import { createGlobalStyle } from 'styled-components';
import { normalize } from 'styled-normalize';

export const GlobalStyle = createGlobalStyle`
  ${normalize}
  
  body {
    font-family: 'Nunito', sans-serif;
    color: #333;
    font-size: 14px;
  }
`;
